<style lang="scss">
    @import "@/assets/scss/vuexy/pages/Config.scss";
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4 edit-information-view">
        <div class="vx-col w-full">
          <vs-button :to="`/energy/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
        </div>
        <div class="vx-col w-full">
            <vx-card class="grid-view-item mb-base overflow-hidden">
                <h4>
                    {{$t("Labels.CostSetup")}}
                </h4>
                <form class="edit-form">
                    <div class="item-grid-view vx-row match-height mt-4">
                        <div class="lg:w-1/3 sm:w-1/3 w-full px-4">
                          <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                              <label for="" class="vs-input--label">{{$t("Labels.Cost")}} Wh</label>
                              <vs-input-number v-model="cost"/>
                            </div>
                          </div>
                          <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                              <label for="" class="vs-input--label">{{$t("Labels.CuttingDay")}}</label>
                              <vs-select  v-model="select" name="included"  class="select-large w-full">
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options" />
                              </vs-select>
                            </div>
                          </div>
                          <div class="vx-row">
                            <div class="vx-col w-full">
                              <vs-button  @click="formSubmit" class="mr-3 mb-2">{{$t("Labels.Save")}}</vs-button>
                            </div>
                          </div>
                        </div>
                        <div class="lg:w-1/3 sm:w-1/3 w-full px-4">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                              <label for="" class="vs-input--label">{{$t("Labels.LastCost")}}</label>
                            </div>

                            <vs-table :data="records">
                              <template slot="thead">
                                <vs-th>{{$t("Labels.Cost")}}</vs-th>
                                <vs-th>{{$t("Labels.Date")}}</vs-th>
                              </template>
                              <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                  <vs-td :data="data[indextr].email">
                                    {{ data[indextr].cost }}
                                  </vs-td>
                                  <vs-td :data="data[indextr].username">
                                    {{ data[indextr].created_at }}
                                  </vs-td>
                                </vs-tr>
                              </template>
                            </vs-table>

                          </div>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>
<script>
import 'leaflet/dist/leaflet.css'
import { request } from '@/request.js'

export default {
  components: {

  },
  data () {
    return {
      response: [],
      records: [],
      cost: 0,
      select: '',
      options: [
        { text: 'No Definido', value: 0 },
        { text: 'Día 1 del mes', value: 1 },
        { text: 'Día 2 del mes', value: 2 },
        { text: 'Día 3 del mes', value: 3 },
        { text: 'Día 4 del mes', value: 4 },
        { text: 'Día 5 del mes', value: 5 },
        { text: 'Día 6 del mes', value: 6 },
        { text: 'Día 7 del mes', value: 7 },
        { text: 'Día 8 del mes', value: 8 },
        { text: 'Día 9 del mes', value: 9 },
        { text: 'Día 10 del mes', value: 10 },
        { text: 'Día 11 del mes', value: 11 },
        { text: 'Día 12 del mes', value: 12 },
        { text: 'Día 13 del mes', value: 13 },
        { text: 'Día 14 del mes', value: 14 },
        { text: 'Día 15 del mes', value: 15 },
        { text: 'Día 16 del mes', value: 16 },
        { text: 'Día 17 del mes', value: 17 },
        { text: 'Día 18 del mes', value: 18 },
        { text: 'Día 19 del mes', value: 19 },
        { text: 'Día 20 del mes', value: 20 },
        { text: 'Día 21 del mes', value: 21 },
        { text: 'Día 22 del mes', value: 22 },
        { text: 'Día 23 del mes', value: 23 },
        { text: 'Día 24 del mes', value: 24 },
        { text: 'Día 25 del mes', value: 25 },
        { text: 'Día 26 del mes', value: 26 },
        { text: 'Día 27 del mes', value: 27 },
        { text: 'Día 28 del mes', value: 28 },
        { text: 'Día 29 del mes', value: 29 },
        { text: 'Día 30 del mes', value: 30 }
      ],
      uuid: this.$route.params.uuid
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: 'modelo/cost/E',
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.cost = this.response.modelo_cost_record.cost
        this.select = parseInt(this.response.cutting_day)
      })
    },
    async getRecords () {
      const params = {
        url: 'modelo/cost?limit=5&offset=0&byColumn=created_at&byOrder=desc&device=E',
        method: 'GET'
      }
      await request(params).then(response => {
        this.records = response.data.data.rows
      })
    },
    async formSubmit (e) {
      e.preventDefault()
      console.log(this.select)
      const params = {
        url: 'modelo/cost',
        method: 'POST',
        params: {
          cost: this.cost,
          device: 'E',
          cutting_day: this.select
        }
      }
      await request(params)
    },
    onTimeChange (value) {
      this.response.time = value
    },
    onUnityChange (value) {
      this.response.time_unity = value
    }
  },

  created () {
    this.getResponse()
    this.getRecords()
  }
}
</script>
